import React from 'react';
import { Typography } from '@mui/material';

/**
 * @param {import('@mui/material').TypographyProps} props
 */
export const Subtitle = ({ children, ...props }) => (
  <Typography variant="body2" color="text.secondary" align="center" {...props}>
    {children}
  </Typography>
);
